import { render, staticRenderFns } from "./ChoosePositionDialog.vue?vue&type=template&id=1990296c&scoped=true&"
import script from "./ChoosePositionDialog.vue?vue&type=script&lang=js&"
export * from "./ChoosePositionDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePositionDialog.vue?vue&type=style&index=0&id=1990296c&prod&scoped=true&lang=css&"
import style1 from "./ChoosePositionDialog.vue?vue&type=style&index=1&id=1990296c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1990296c",
  null
  
)

export default component.exports